type TimeUnitKeys =
	| 'one'
	| 'three'
	| 'two'
	| 'five'
	| 'ten'
	| 'thirty'
	| 'fifty'
	| 'oneHundred'
	| 'oneHundredFifty'
	| 'twoHundred'
	| 'twoHundredFifty'
	| 'twoHundredEighty'
	| 'threeHundred'
	| 'threeHundredFifty'
	| 'threeHundredEighty'
	| 'fourHundred'
	| 'fourHundredFifty'
	| 'fourHundredEighty'
	| 'fiveHundred'
	| 'fiveHundredFifty'
	| 'fiveHundredEighty'
	| 'sixHundred'
	| 'sixHundredFifty'
	| 'sevenHundred'
	| 'sevenHundredFifty'
	| 'eightHundred'
	| 'eightHundredFifty'
	| 'nineHundred'
	| 'nineHundredFifty'
	| 'oneThousand';

type TimeUnits = {
	[key in TimeUnitKeys]: number;
};

type TimeSpanType = {
	milliSecond: TimeUnits;
	seconds: TimeUnits;
	minutes: TimeUnits;
	hours: TimeUnits;
	zero: number;
};

export const TimeSpan: TimeSpanType = {
	milliSecond: {
		one: 1,
		three: 3,
		two: 2,
		five: 5,
		ten: 10,
		thirty: 30,
		fifty: 50,
		oneHundred: 100,
		oneHundredFifty: 150,
		twoHundred: 200,
		twoHundredFifty: 250,
		twoHundredEighty: 280,
		threeHundred: 300,
		threeHundredFifty: 350,
		threeHundredEighty: 380,
		fourHundred: 400,
		fourHundredFifty: 450,
		fourHundredEighty: 480,
		fiveHundred: 500,
		fiveHundredFifty: 550,
		fiveHundredEighty: 580,
		sixHundred: 600,
		sixHundredFifty: 650,
		sevenHundred: 700,
		sevenHundredFifty: 750,
		eightHundred: 800,
		eightHundredFifty: 850,
		nineHundred: 900,
		nineHundredFifty: 950,
		oneThousand: 1000
	},
	seconds: {
		one: 1000,
		three: 3 * 1000,
		two: 2 * 1000,
		five: 5 * 1000,
		ten: 10 * 1000,
		thirty: 30 * 1000,
		fifty: 50 * 1000,
		oneHundred: 100 * 1000,
		oneHundredFifty: 150 * 1000,
		twoHundred: 200 * 1000,
		twoHundredFifty: 250 * 1000,
		twoHundredEighty: 280 * 1000,
		threeHundred: 300 * 1000,
		threeHundredFifty: 350 * 1000,
		threeHundredEighty: 380 * 1000,
		fourHundred: 400 * 1000,
		fourHundredFifty: 450 * 1000,
		fourHundredEighty: 480 * 1000,
		fiveHundred: 500 * 1000,
		fiveHundredFifty: 550 * 1000,
		fiveHundredEighty: 580 * 1000,
		sixHundred: 600 * 1000,
		sixHundredFifty: 650 * 1000,
		sevenHundred: 700 * 1000,
		sevenHundredFifty: 750 * 1000,
		eightHundred: 800 * 1000,
		eightHundredFifty: 850 * 1000,
		nineHundred: 900 * 1000,
		nineHundredFifty: 950 * 1000,
		oneThousand: 1000 * 1000
	},
	minutes: {
		one: 1000 * 60,
		three: 3 * 1000 * 60,
		two: 2 * 1000 * 60,
		five: 5 * 1000 * 60,
		ten: 10 * 1000 * 60,
		thirty: 30 * 1000 * 60,
		fifty: 50 * 1000 * 60,
		oneHundred: 100 * 1000 * 60,
		oneHundredFifty: 150 * 1000 * 60,
		twoHundred: 200 * 1000 * 60,
		twoHundredFifty: 250 * 1000 * 60,
		twoHundredEighty: 280 * 1000 * 60,
		threeHundred: 300 * 1000 * 60,
		threeHundredFifty: 350 * 1000 * 60,
		threeHundredEighty: 380 * 1000 * 60,
		fourHundred: 400 * 1000 * 60,
		fourHundredFifty: 450 * 1000 * 60,
		fourHundredEighty: 480 * 1000 * 60,
		fiveHundred: 500 * 1000 * 60,
		fiveHundredFifty: 550 * 1000 * 60,
		fiveHundredEighty: 580 * 1000 * 60,
		sixHundred: 600 * 1000 * 60,
		sixHundredFifty: 650 * 1000 * 60,
		sevenHundred: 700 * 1000 * 60,
		sevenHundredFifty: 750 * 1000 * 60,
		eightHundred: 800 * 1000 * 60,
		eightHundredFifty: 850 * 1000 * 60,
		nineHundred: 900 * 1000 * 60,
		nineHundredFifty: 950 * 1000 * 60,
		oneThousand: 1000 * 1000 * 60
	},
	hours: {
		one: 1000 * 60 * 60,
		three: 3 * 1000 * 60 * 60,
		two: 2 * 1000 * 60 * 60,
		five: 5 * 1000 * 60 * 60,
		ten: 10 * 1000 * 60 * 60,
		thirty: 30 * 1000 * 60 * 60,
		fifty: 50 * 1000 * 60 * 60,
		oneHundred: 100 * 1000 * 60 * 60,
		oneHundredFifty: 150 * 1000 * 60 * 60,
		twoHundred: 200 * 1000 * 60 * 60,
		twoHundredFifty: 250 * 1000 * 60 * 60,
		twoHundredEighty: 280 * 1000 * 60 * 60,
		threeHundred: 300 * 1000 * 60 * 60,
		threeHundredFifty: 350 * 1000 * 60 * 60,
		threeHundredEighty: 380 * 1000 * 60 * 60,
		fourHundred: 400 * 1000 * 60 * 60,
		fourHundredFifty: 450 * 1000 * 60 * 60,
		fourHundredEighty: 480 * 1000 * 60 * 60,
		fiveHundred: 500 * 1000 * 60 * 60,
		fiveHundredFifty: 550 * 1000 * 60 * 60,
		fiveHundredEighty: 580 * 1000 * 60 * 60,
		sixHundred: 600 * 1000 * 60 * 60,
		sixHundredFifty: 650 * 1000 * 60 * 60,
		sevenHundred: 700 * 1000 * 60 * 60,
		sevenHundredFifty: 750 * 1000 * 60 * 60,
		eightHundred: 800 * 1000 * 60 * 60,
		eightHundredFifty: 850 * 1000 * 60 * 60,
		nineHundred: 900 * 1000 * 60 * 60,
		nineHundredFifty: 950 * 1000 * 60 * 60,
		oneThousand: 1000 * 1000 * 60 * 60
	},
	zero: 0
};
